<div class="ap-margin-bottom-3">
    {{ 'extra-asset.own-money-amount.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>

<ap-amount-input
    id="ownMoneyAmount"
    [helpText]="'extra-asset.own-money.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="extra-asset.own-money-amount.amount.additional-info.text"
    contentKey="extra-asset.own-money-amount.amount.additional-info.content"
    modalUrlKey="extra-asset.own-money-amount.amount.additional-info.text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
